import { Fragment } from "react"
import { Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { options } from "../util"
import { styles } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields/util"
export default function SelectPlanType({ formik, employer }) {
    const { errors, touched } = formik
    const planOptions = options.plans(employer)

    return (
        <Fragment>
            <Stack sx={{ marginTop: "20px" }}>
                <Typography sx={{ marginBottom: "8px" }}>
                    Plan Type
                </Typography>
                <Field name="newPlan">
                    {({ field }) => (
                        <select
                            {...field}
                            style={{...styles.select(!field.value), border: `1px solid ${errors.newPlan && touched.newPlan ? "#dc2626" : "#ACBEE8"}`}}
                        >
                            <option value="">Select Plan Type</option>
                            {planOptions && planOptions.map((plan, index) => (
                                <option key={index} value={plan.planType}>
                                    {plan.name}
                                </option>
                            ))}
                        </select>
                    )}
                </Field>
                {errors.newPlan && touched.newPlan && (
                    <div className="error-message-fields">{errors.newPlan}</div>
                )}
            </Stack>
        </Fragment>
    )
}